export const analytic_places = {
    getStatistics: (userId,placeId, period, type, dateFrom, dateTo) => ({
        api: `/api/v2/systemManagers/${userId}/machines/${placeId}/statistics?${type ? `type=${type}&` : ""}${period ? `period=${period}&` : ""}${dateFrom && period === 'date' ? `dateFrom=${dateFrom}&` : ""}${dateTo && period === 'date' ? `dateTo=${dateTo}&` : ""}`,
        method: "GET"
    }),
    getPlaces: (userId) => ({api: `/api/v2/systemManagers/${userId}/machines`, method: "GET"}),
}